import { useSelector } from 'react-redux';

export const CartItemsCount = () => {
    const cart = useSelector(store => store.cart);
    
    return cart.length > 0 ?

    <div data-test-id="cart-qty" className="ant-scroll-number ng-trigger ng-trigger-zoomBadgeMotion ant-badge-count ant-badge-multiple-words ng-star-inserted">{cart.length>99?'99+':cart.length}</div>
    : null
}
